module.exports = __webpack_public_path__ + "img/svg - school leaders.ff3ffc77.svg";